export const deprecatedColors = {
    // Base pink
    basePink: '#f8dadf',

    // Secondary pinks
    secondary1: '#f6cdd4',
    secondary2: '#fbb5c3',
    secondary3: '#ffa4b4',
    secondary4: '#ed80a8',
    secondary5: '#e74683',
    secondary6: '#f3716d',
    secondary7: '#d7006d',

    // Tertiary Colors - Purples
    purple1: '#c9bcd0',
    purple2: '#a391b2',
    purple3: '#7e6990',
    purple4: '#644b78',
    purple5: '#402b56',

    // Tertiary Colors - Grays
    gray1: '#dbd9d6',
    gray2: '#8a8c8c',
    gray3: '#555759',
    gray4: '#111820',
    gray5: '#f5f5f5',

    // Other
    green: '#51b10b',

    // Colors not in Graphical Profile
    accentPink: '#f9dadF',
    veryLightGray: '#F8F8F8',
    black: '#000000',
    white: '#ffffff',
    white2: '#fafafa',
    red: '#ff0000',
    darkRed: '#be1958',

    transparent: {
        white50: '#ffffff88',
        white67: '#ffffffaa',
    },
} as const;
